const state = () => ({
  categoryStatuses: [],
});

const getters = {
  categoryStatuses: state => state.categoryStatuses,
  notStartedStatus: state => state.categoryStatuses.find(fs => fs.name == 'not-started'),
  completedStatus: state => state.categoryStatuses.find(fs => fs.name == 'completed'),
  inProgressStatus: state => state.categoryStatuses.find(fs => fs.name == 'in-progress'),
};

const mutations = {
  setCategoryStatuses(state, statuses) {
    state.categoryStatuses = statuses;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
